import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
declare var ace: any;
@pbi.Component({
    selector: 'order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.css']
})

export class OrderComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: Object[];
    PageTitle: string = "Quản lý đơn hàng";
    //#region Order
    Title: string = "";
    ID: string = "-1";
    Name: string = "";
    HoTen: string = "";
    DiaChi: string = "";
    SoDienThoai: string = "";
    Email: string = "";
    LoiNhan: string = "";
    TrangThai: string = "";
    Description: string = "";
    DongHang: Object = [];
    Active: boolean = false;
    Action: string = "";
    LinkOrg: string = "";
    //#endregion Order
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        var editModal = $('#EditOrderModal');
        this_sav.pb_func.loadScript([
            'assets/global/scripts/datatable.js',
            'assets/global/plugins/datatables/datatables.min.js',
            'assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.js',
            'assets/global/plugins/jstree/dist/jstree.min.js',
            'assets/pages/scripts/ui-tree.min.js',
            'assets/global/plugins/jquery-inputmask/jquery.inputmask.bundle.min.js',
            'assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js',
            'assets/src-noconflict/ace.js',
            'assets/more/script/fixHeightContent.js'
        ], 'order', function () {
            this_sav.tableOrder();
        });
    };

    //#region Load Table Select
    tableOrder() {
        var this_sav = this;
        var url = this_sav.pb_func.getBaseUrl() + "api/Order/load";
        var table = $('#datatable_ajax');
        
        var tbl = table.DataTable({
            "bProcessing": true,
            "bServerSide": true,
            "sAjaxSource": url,
            "bSort" : false,
            "fnServerData": function (sSource, aoData, fnCallback, oSettings) {
                oSettings.jqXHR = $.ajax({
                    "dataType": 'json',
                    "type": "POST",
                    "url": sSource,
                    "data": aoData,
                    "headers": { 'Authorization': this_sav.pb_func.getToken() },
                    "success": function(json) {
                        this_sav.items = json.aaData;
                        if (this_sav.items.length > 0) {
                            this_sav.LinkOrg = this_sav.items[0]["LinkOrg"];
                        }
                        fnCallback(json);
                    },
                });
            },
            "columns": [
                { "data": null },
                { "data": "NameAction", "className": "dt-center" },
                { "data": "DongHangAction", "className": "dt-center" },
                { "data": "HoTen" },
                { "data": "DiaChi" },
                { "data": "SoDienThoai" },
                { "data": "Email" },
                { "data": "TrangThaiAction", "className": "dt-center" }
            ],
            "lengthMenu": [
                [5],
                [5]
            ],
            "pageLength": 5,
            "drawCallback": function (settings) {
                $('.EditDongHangModal').off('click');
                $('.EditDongHangModal').click(function () {
                    this_sav.EditDongHangModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });

                $('.EditTrangThaiModal').off('click');
                $('.EditTrangThaiModal').click(function () {
                    this_sav.EditTrangThaiModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });

                $('.EditNameModal').off('click');
                $('.EditNameModal').click(function () {
                    this_sav.EditNameModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
            },
            "rowCallback": function (row, data, displayNum, displayIndex, dataIndex) {
                var page = this.fnPagingInfo().iPage;
                var length = this.fnPagingInfo().iLength;
                var index = (page * length + (displayIndex + 1));
                $('td:eq(0)', row).html(index);
            },
            "initComplete": function (settings, json) {
                this_sav.adminService.closeLoading(() => {

                });
            }
        });
    }

    ReLoadTable() {
        var table = $('#datatable_ajax').DataTable();
        table.ajax.reload(null, false);
    }
    //#endregion Load Table Select

    //#region Modal
    EditDongHangModal($event, ID, typesp) {
        var this_sav = this;
        var a = $event;
        this_sav.ID = ID;
        var jsonSP = this_sav.items.filter(function(item) {
            return item['ID'] == ID
        });

        if(jsonSP.length > 0) {
            this_sav.Name = jsonSP[0]['Name']; 
            var DongHang = jsonSP[0]['DongHang'];
            this_sav.DongHang = JSON.parse(DongHang);
        }
        
        $(a).next().click();
    }

    EditTrangThaiModal($event, ID, typesp) {
        var this_sav = this;
        var a = $event;
        this_sav.ID = ID;
        var jsonSP = this_sav.items.filter(function(item) {
            return item['ID'] == ID
        });

        if(jsonSP.length > 0) {
            this_sav.Name = jsonSP[0]['Name'];
            $('#EditTrangThaiModal').find('.TrangThai').val(jsonSP[0]['TrangThai']);
        }
        
        $(a).next().click();
    }

    EditNameModal($event, ID, typesp) {
        var this_sav = this;
        var a = $event;
        this_sav.ID = ID;
        var jsonSP = this_sav.items.filter(function(item) {
            return item['ID'] == ID
        });

        if(jsonSP.length > 0) {
            this_sav.Name = jsonSP[0]['Name']; 
            this_sav.DiaChi = jsonSP[0]['DiaChi'];
            this_sav.LoiNhan = jsonSP[0]['LoiNhan'];
            this_sav.Description = jsonSP[0]['Description'];
            setTimeout(() => { $('#EditNameModal').find('.autofocus').focus(); }, 500);
        }
        
        $(a).next().click();
    }
    //#endregion Modal

    //#region Update
    UpdateOrder($event, type) {
        var this_sav = this;
        var editModal =  $('#EditTrangThaiModal');
        if(type == "updateDescription") {
            editModal =  $('#EditNameModal');
        }
        this_sav.TrangThai = editModal.find('.TrangThai').val();
        var table = $('#datatable_ajax').DataTable();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Order/Update', 'POST',
        {
            ID: this_sav.ID, TrangThai: this_sav.TrangThai, 
            Description: this_sav.Description ,Type: type
        },
        null, function (status, mess) {
            this_sav.adminService.closeLoading(function () { });
            var elemNotify = editModal.find('.notifyModal');

            if (status == 0) {
                elemNotify.notify(mess.toString(), { position: 'bottom right', className: 'error' });
            }
            else {
                table.ajax.reload(null, false);
                $.notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                editModal.find('.close').click();
            }
        });
    }
    //#endregion Update
}


// WEBPACK FOOTER //
// ./src/app/admin/order/order.component.ts